import React from 'react'
import { FavoriteIcon } from 'components/patterns/icons'
import { colors } from 'parameters'
import styled from '@emotion/styled'
import { useFavorite } from 'stores/Favorites'
import { useAuthState } from 'services/Authentication'
import { ClientOnlyRender } from 'lib/renderWrappers/ClientOnly'

interface IsFaveProps {
	isFavorite: boolean
}

interface Props {
	id: string
	Element?: React.FC<React.PropsWithChildren<IsFaveProps>>
}

const DefaultElement: React.FC<React.PropsWithChildren<IsFaveProps>> = ({ isFavorite }) => (
	<FavoriteIcon
		color={isFavorite ? colors.primaryPurple1 : colors.white}
		outline={isFavorite ? colors.primaryPurple1 : colors.primaryDarkGrey1}
	/>
)

export const FavoriteButton: React.FC<React.PropsWithChildren<Props>> = ({ id, Element = DefaultElement }) => {
	const [favorite, { toggleFavorite }] = useFavorite({ id })
	const { userType } = useAuthState()

	return (
		<ClientOnlyRender>
			<Icon
				onClick={event => {
					event.preventDefault()
					toggleFavorite(id)
				}}
			>
				{userType === 'loggedIn' && <Element isFavorite={favorite !== undefined} />}
			</Icon>
		</ClientOnlyRender>
	)
}

const Icon = styled.div`
	display: flex;
	cursor: pointer;
	min-width: 22px;
	min-height: 22px;
`
